<template>
    <div class="selective-disease">
        <img src="@/assets/images/cartojourney/img01.png" class="img-bg" alt="">
        <div class="top-con">
            <img src="@/assets/images/cartojourney/img08.png" class="con-title" alt="">
        </div>
        <div class="con-list">
            <div class="con-items" v-for="(item, index) in technology" :key="index" @click="handleClickItems(item, index)" :class="item.check ? 'ischecked' : ''">
                <div class="items-checked items-istrue">
                    <img src="@/assets/images/cartojourney/img05.png" v-if="item && item.check" class="icon-check" alt="">
                    <img src="@/assets/images/cartojourney/img06.png" v-else class="icon-check" alt="">
                </div>
                <span class="items-txt">{{ item && item.technologyName }}</span>
            </div>
        </div>
        <div class="submit-btn" @click="handleSubmit">确定</div>
    </div>
</template>
<script>
import {technologyList, customizedChangeTechnology, journeyTops} from '@/api/cartoJourney.js'
import withRouteTracking from '@/utils/withRouteTracking'
import { debounce } from '@/utils/util'
const UserProfile = {
  data() {
    return {
      technology: []
    }
  },
  mounted() {
    this.customizedCode = this.$route.query.customizedCode
    this.customizedMultiCode = this.$route.query.customizedMultiCode
    technologyList({customizedId: this.customizedCode}).then(res => {
      this.technology = res.data.map(item => {
        item.check = false
        return item
      }).filter(item => `${item.isOptional}` === '1')
      this.handleFun()
    })
  },
  methods: {
    async handleFun() {
      let journeys = await journeyTops({customizedCode: this.customizedCode})
      let technologysTxt = journeys.data.technologys ? journeys.data.technologys.split('；') : []
      this.technology.map(item => {
        if (technologysTxt.includes(item.technologyName)) {
          item.check = true
        }
      })
    },
    handleClickItems(item, index) {
      this.technology[index].check = !item.check
    },
    handleSubmit: debounce(function() {
      let params = {
        customizedCode: this.$route.query.customizedCode,
        technologyNames: this.technology.filter((res) => res.check).map(res => res.technologyName)
      }
      sessionStorage.removeItem('selectCurrentJourney')
      customizedChangeTechnology(params).then(res => {
        if (res.code === 0) {
          this.$router.push({
            path: '/journeyPage',
            query: {
              customizedMultiCode: this.customizedMultiCode,
              customizedCode: this.customizedCode
            },
          })
        }
      })
    }, 500)
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.selective-disease {
    min-height: 100vh;
    background-color: #F0F1F6;
    padding-bottom: 72px;
    box-sizing: border-box;
    .img-bg {
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1;
    }
    .top-con {
        background-image: url('../../assets/images/cartojourney/img01.png');
        background-repeat: no-repeat;
        background-size: 100% auto;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 65px;
        z-index: 9;
        padding-left: 12px;
        padding-top: 27px;
        box-sizing: border-box;
        .con-title {
            width: 125px;
            display: block;
        }
    }
    .con-list {
        position: relative;
        padding: 0 12px;
        box-sizing: border-box;
        padding-top: 65px;
        z-index: 2;
        .con-items {
            background-color: #fff;
            border-radius: 8px;
            display: flex;
            align-items: center;
            height: 48px;
            box-sizing: border-box;
            margin-bottom: 8px;
            position: relative;
            padding: 0 12px;
            &.ischecked {
                border: 1px solid #000;
                box-sizing: border-box;
            }
            .items-checked {
                border-radius: 8px;
                margin-right: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                .icon-check {
                    width: 20px;
                    display: block;
                }
            }
            .items-txt {
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: 500;
                font-size: 16px;
                color: #000;
            }
        }
    }
    .submit-btn {
        background-color: #EB1700;
        position: fixed;
        left: 10px;
        width: calc(100% - 20px);
        height: 42px;
        line-height: 42px;
        text-align: center;
        bottom: 15px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        border-radius: 100px;
        z-index: 9;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/cartoJourney/selectiveTechnique.vue